import { ESize } from '@/models/enums';
import { Container } from '../Container/Container';
import { Logo } from '../Logo/Logo';
import { HeaderProps } from './Header.interfaces';
import { cn } from '@/utils';

export const Header = ({ logo, variant = 'primary', additionalClassNames, middleChildren, rightHandSideChildren }: HeaderProps) => {
  return (
    <header>
      <nav
        className={cn(
          'relative z-20 kanzi-no-print',
          {
            'bg-primary': variant === 'primary',
            'bg-surface text-surface-foreground': variant === 'surface',
          },
          additionalClassNames,
        )}
      >
        <Container additionalClassNames="relative py-4 grid grid-cols-[auto_1fr_auto] items-center" size={ESize.FULL}>
          <Logo {...logo} variant={variant} />
          <div className="flex justify-center items-center">{middleChildren}</div>
          <div className="flex justify-end items-center gap-4">{rightHandSideChildren}</div>
        </Container>
      </nav>
    </header>
  );
};
